import React, { CSSProperties, FC } from 'react';

import { Icon } from '@column/column-ui-kit';

// Kept in sync with the Create Transfer tab redesign's `TemplatesIcon` (TransferTypePicker/catalog.tsx).
// The ui-kit's CSV icon hardcodes a light gray (`--icon-color`); this makes it inherit the text color.
const inheritColor = { '--icon-color': 'currentColor' } as CSSProperties;
export const TemplatesIcon: FC = () => <Icon.Csv style={inheritColor} />;
